import { FC, useEffect } from "react";
import styled, { useTheme } from "styled-components";
import PageWrapper from "../components/common/PageWrapper";
import { CheckIcon } from "../components/Icons";

const SuccessScreenWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: normal;
	width: 100%;
	height: 100vh;
	background-color: ${props => props.theme.colors.primary};
	color: ${props => (props.theme.colors.whiteVitat || "#002b49")};
`;

const SucessMessage = styled.p`
	font-family: Livvic;
	font-style: normal;
	line-height: 135%;
	text-align: center;
	color: ${props => (props.theme.colors.whiteVitat || "#002b49")};
	margin-left: 32px;
	margin-right: 32px;
	margin-top: 20px;
	margin-bottom: 0px;
`;

const ReturnButton = styled.button`
	all: unset;
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 165.5%;
	text-align: center;
	letter-spacing: 0.005em;
	color: ${props => (props.theme.colors.whiteVitat || "#002b49")};
	margin: 10px;
`;
/**
 * ### Tela de sucesso
 * Mostra uma mensagem de sucesso para o usuário e da uma opção de voltar para a tela principal.
 * O usuário não consegue sair dessa tela, apenas fechando a webview
 */
const SuccessScreen: FC = () => {
	const theme = useTheme();

	const status = sessionStorage.getItem("status");

	useEffect(() => {
		sessionStorage.setItem("showSuccessScreen", "true");
	}, []);

	const handleReturnButtonClick = () => {
		window.open("https://api.cuidai.com.br/?finish=true", "_self");
	};

	return (
		<PageWrapper backgroundColor={theme.colors.primary}>
			<SuccessScreenWrapper>
				<CheckIcon color={theme.colors.whiteVitat || "#002B49"} size={40} />
				<SucessMessage>
				{status === 'canceled' && <span style={{ fontSize: 32, fontWeight: "bold" }}>Consulta cancelada!</span>}

				{status === 'rescheduled' && (
					<>
					<span style={{ fontSize: 32, fontWeight: "bold" }}>Consulta reagendada!</span><br />
					<span style={{ fontSize: 14 }}>Em instantes ela será exibida na tela inicial</span>
					</>
				)}

				{status === 'scheduled' && (
					<>
					<span style={{ fontSize: 32, fontWeight: "bold" }}>Consulta agendada!</span><br />
					<span style={{ fontSize: 14 }}>Em instantes ela será exibida na tela inicial</span>
					</>
				)}
				</SucessMessage>
				<ReturnButton type="button" onClick={handleReturnButtonClick}>
					Retornar para o início
				</ReturnButton>
			</SuccessScreenWrapper>
		</PageWrapper>
	);
};

export default SuccessScreen;
